import { render, staticRenderFns } from "./ConsumerFooter.vue?vue&type=template&id=bf7783e0&scoped=true"
import script from "./ConsumerFooter.vue?vue&type=script&lang=js"
export * from "./ConsumerFooter.vue?vue&type=script&lang=js"
import style0 from "./ConsumerFooter.vue?vue&type=style&index=0&id=bf7783e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7783e0",
  null
  
)

export default component.exports